module.exports = __webpack_public_path__ + "static/media/logo3.25a031ec.jpg";